import { Spin, SpinSize } from 'lego-on-react';
import React from 'react';

import block from 'propmods';

import './Loading.scss';

const b = block('Loading');

interface Props {
    size?: SpinSize;
    centered?: boolean;
    className?: string;
    grow?: boolean;
}

export const Loading: React.SFC<Props> = ({ size = 'l', centered, grow }) => (
    <div {...b({ centered, grow })}>
        <div {...b('spinner')}>
            <Spin size={size} progress />
        </div>
    </div>
);
